import api from "./api";

export const getInventoriesApi = async (body: {
  limit: number;
  q: string;
  isActive?: boolean;
}) => {
  let url = `/inventories?limit=${body.limit}&q=${body.q.toString()}`;

  if (body.isActive !== undefined) {
    url += `&isActive=${body.isActive}`;
  }

  return await api.get(url);
};

/*Inventory Details search filter */

export const getInventoriesDetailsApi = async (
  inventoryid: string | number | undefined,
  sourceSearch: string
) => {
  let url = `/inventories/${inventoryid}/SP_details?sourceSearch=${sourceSearch.toString()}`;
  return await api.get(url);
};

export const getWarehouseInventories = async (warehouseId: number) => {
  return await api.get(`/inventories/warehouse/${warehouseId}`);
};
